import {VBtn} from 'vuetify/lib'
import {getLoginInfoApi, getPassWordInfoApi} from '@/views/fin/account_management/services.js'
import { getsafe } from '@/libs/util'
const Password = {
    props: {
        id: {
            type: Number,
        }
    },
    data() {
       return {
            password: '',
            loading:false,
       }
    },
    methods: {
        getPassword() {
            this.loading = true
            getPassWordInfoApi(this.id, {type: 'login'}).then(res => {
                this.password = res
            }).finally(() => {
                this.loading = false
            })
        }
    },
    render() {
        return <span>
            {this.password || '*****'}<span>
                <VBtn text color="primary" loading={this.loading} on={{
                    click:this.getPassword
                }}>查看</VBtn></span>
        </span>
    }
}
export default {
    props: {
        id: {
            type: Number || String
        },
        target: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        getData() {
            const id = this.id
            const virtual = getsafe(this.target, 'virtual')
            if (virtual) {
                this.$vModal.error({
                    title:'提示',
                    content:'无登录信息'
                })
                return 
            }
            this.loading = true
            getLoginInfoApi(id).then(res => {
                const account = res.account || {}
                this.$vModal.info({
                    title: '提示',
                    render:() => {
                        return <div>
                            <p>
                                网址：{account.platformLink}
                            </p>
                            <p>
                                账户：{account.account}
                            </p>
                            <p>
                                密码：{account.loginMethod !== 4 ? <Password id={account.id}/> : '手机扫码（无需密码）'}
                            </p>
                        </div>
                    }
                })
            }).finally(() => {
                this.loading = false
            })
        }
    },
    render() {
        return <VBtn 
            text 
            color="primary" 
            loading={this.loading}
            on={{
                click:this.getData
        }}>登录信息</VBtn>
    }
}